import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { configurations } from './configurations';

function* paymentSagas() {
  yield mapSagasFromConfigurations('payment')(configurations)
}

export default paymentSagas;



// WEBPACK FOOTER //
// ./src/state/modules/payment/sagas.js